module.exports = __webpack_public_path__ + "img/26.db416094.webp";